const getEmail = (): string => {
  return localStorage.getItem('email') as string;
};

interface UserInformation {
  defaultStage: string;
}

const getUserInformation = (): UserInformation => {
  return JSON.parse(localStorage.getItem(getEmail()) as string);
};

export const setDefaultStage = (stage: string): void => {
  localStorage.setItem(getEmail(), JSON.stringify({ ...getUserInformation(), defaultStage: stage }));
};

export const getDefaultStage = (): string | null => {
  return getUserInformation()?.defaultStage;
};
